import { useDeviceType } from '@cian/ui-kit';
import { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCertificates } from '../../../selectors/builder';
import { IDocument } from '../../../types/builder';
import { DESKTOP_COLLAPSED_ITEMS_COUNT, MOBILE_COLLAPSED_ITEMS_COUNT } from '../constants';

export interface IUseDocumentListReturnType {
  list: IDocument[];
  expandable: boolean;
  inColumn: boolean;
  expanded: boolean;
  toggleExpanded(): void;
}

export const useDocumentsList = (): IUseDocumentListReturnType => {
  const documents = useSelector(selectCertificates);
  const device = useDeviceType();
  const isDesktop = device === 'desktop';

  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = useCallback(() => setExpanded(!expanded), [expanded]);

  const collapsedDocumentsCount = useMemo(
    () => (isDesktop ? DESKTOP_COLLAPSED_ITEMS_COUNT : MOBILE_COLLAPSED_ITEMS_COUNT),
    [isDesktop],
  );

  const list = useMemo(
    () => (expanded ? documents : documents.slice(0, collapsedDocumentsCount)),
    [documents, collapsedDocumentsCount, expanded],
  );

  return {
    list,
    expandable: documents.length > collapsedDocumentsCount,
    inColumn: !isDesktop,
    expanded,
    toggleExpanded,
  };
};
